import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiToggleButtonGroup: MuiComponent<"MuiToggleButtonGroup"> = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      padding: '4px',
      border: `1px solid ${Colors.BorderGray}`,
      width: 'fit-content',
      gap: '2px',
    },
  },
}

export const MuiToggleButton: MuiComponent<"MuiToggleButton"> = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      padding: '3px 16px',
      textTransform: 'none',
      fontSize: '14px',
      border: 'none',
      color: Colors.TableHeaderText,
      fontWeight: '400',
      
      '&.Mui-selected': {
        borderRadius: '8px',
        backgroundColor: Colors.Surface,
        border: `1px solid #4A4A4A40`,
        fontWeight: '500',
      },

      '&:hover': {
        borderRadius: '8px',
      },
    },
  },
}